module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "device-info-boxes"
  }, [_c('hamv-info-box', {
    attrs: {
      "title": _vm.$t('deviceInfoBoxesTitleDevicesText'),
      "total": _vm.numberOfDevices,
      "classes": "fa fa-lightbulb-o"
    }
  }), _vm._v(" "), _c('hamv-info-box', {
    attrs: {
      "title": _vm.$t('deviceInfoBoxesTitleOnlineText'),
      "total": _vm.numberOfConnection,
      "classes": "fa fa-wifi"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d0fa5c14","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DeviceInfoBoxes/DeviceInfoBoxes.vue
// module id = 983
// module chunks = 3